import { baseQuery } from '../baseQuery';
import { type JsonDataItem } from 'types';

export const getTechnicianList = async ({ serviceType, skillIds, suburbId, customerId, getAllTechs }: JsonDataItem) => {
  const skills = skillIds?.length ? skillIds.map((id: string) => (id !== '' ? `&skill_id[]=${id}` : '')).join('') : '';
  const suburb = suburbId ? `&suburb_id=${suburbId}` : '';
  const customer = customerId ? `&customer_id=${customerId}` : '';
  const allTechs = getAllTechs ? '&all_technicians=1' : '';

  const { data } = await baseQuery(
    `list-technicians?service_type=${serviceType}${skills}${suburb}${customer}${allTechs}`,
  );

  return data;
};
